module.exports = __webpack_public_path__ + "images/emoji/taurus.813f4f43143409d78f25.png";